export enum Committee {
  CKE = 1000,
  OKE_Gdansk = 1,
  OKE_Jaworzno = 2,
  OKE_Krakow = 3,
  OKE_Lomza = 4,
  OKE_Lodz = 5,
  OKE_Poznan = 6,
  OKE_Warszawa = 7,
  OKE_Wroclaw = 8,
}

/**
 * Returns an array of Committe Ids without CKE.
 */
export const getCommitteeIds = (): number[] => {
  return Object.keys(Committee)
    .filter((value) => Number(value) && value !== Committee.CKE.toString())
    .map((value) => Number(value));
}

export const getCommitteeLabel = (committeeId: Committee): string => {
  switch (committeeId) {
    case Committee.CKE:
      return 'CKE';
    case Committee.OKE_Gdansk:
      return 'OKE w Gdańsku';
    case Committee.OKE_Jaworzno:
      return 'OKE w Jaworznie';
    case Committee.OKE_Krakow:
      return 'OKE w Krakowie';
    case Committee.OKE_Lomza:
      return 'OKE w Łomży';
    case Committee.OKE_Lodz:
      return 'OKE w Łodzi';
    case Committee.OKE_Poznan:
      return 'OKE w Poznaniu';
    case Committee.OKE_Warszawa:
      return 'OKE w Warszawie';
    case Committee.OKE_Wroclaw:
      return 'OKE we Wrocławiu';
    default:
      return '???';
  }
};

export const getCommitteeId = (label: string): string => {
  switch (label) {
    case 'CKE':
      return Committee.CKE.toString();
    case 'OKE w Gdańsku':
      return Committee.OKE_Gdansk.toString();
    case 'OKE w Jaworznie':
      return Committee.OKE_Jaworzno.toString();
    case 'OKE w Krakowie':
      return Committee.OKE_Krakow.toString();
    case 'OKE w Łomży':
      return Committee.OKE_Lomza.toString();
    case 'OKE w Łodzi':
      return Committee.OKE_Lodz.toString();
    case 'OKE w Poznaniu':
      return Committee.OKE_Poznan.toString();
    case 'OKE w Warszawie':
      return Committee.OKE_Warszawa.toString();
    case 'OKE we Wrocławiu':
      return Committee.OKE_Wroclaw.toString();
    default:
      return '';
  }
};

const getCommitteesArray = (): { id: Committee; name: string }[] => {
  return Object.keys(Committee)
    .filter((v) => !isNaN(Number(v)))
    .map((committeeIdStr: string) => {
      const id: Committee = Number(committeeIdStr) as Committee;
      return { id, name: getCommitteeLabel(id) };
    });
};

export const committeesArray: { id: Committee; name: string }[] = getCommitteesArray();
